import { render, staticRenderFns } from "./LogPolicySettingsModal.vue?vue&type=template&id=a73d8e3c&scoped=true"
import script from "./LogPolicySettingsModal.vue?vue&type=script&lang=ts"
export * from "./LogPolicySettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73d8e3c",
  null
  
)

export default component.exports